/**
 * Created by Gaplo917 on 23/8/2017.
 */
import TWEEN from "@tweenjs/tween.js"

function _fade(displayObject, { alpha, duration, delay }){
  return new Promise((resolve, reject) => {
    new TWEEN.Tween(displayObject)
      .delay(delay)
      .to( { alpha: alpha }, duration)
      .onComplete(() => {
        resolve()
      })
      .start()
  })
}

export class AnimationUtils {

  static fadeIn (displayObject, opt = {}){
    const _alpha = opt.alpha || 1
    const _duration = opt.duration || 1000
    const _delay = opt.delay || 0
    return _fade(displayObject, { alpha: _alpha, duration: _duration, delay: _delay})
  }

  static fadeOut(displayObject, opt = {}){
    const _alpha = opt.alpha || 0
    const _duration = opt.duration || 1000
    const _delay = opt.delay || 0

    return _fade(displayObject, { alpha: _alpha, duration: _duration, delay: _delay})
  }

}



// WEBPACK FOOTER //
// ./src/game/AnimationUtils.js